import { Subject } from 'rxjs/internal/Subject';
import { debounceTime } from 'rxjs/operators';

export class Alert {
  private _info = new Subject<string>();
  private _info_message = '';
  private _success = new Subject<string>();
  private _success_message = '';
  private _warning = new Subject<string>();
  private _warning_message = '';
  private _danger = new Subject<string>();
  private _danger_message = '';

  constructor() {
    this.set_notifications();
  }

  set_notifications() {
    //Info
    this._info.subscribe(message => this._info_message = message);
    this._info.pipe(
      debounceTime(5000)
    ).subscribe(() => this._info_message = '');

    //Success
    this._success.subscribe(message => this._success_message = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this._success_message = '');

    //Warning
    this._warning.subscribe(message => this._warning_message = message);
    this._warning.pipe(
      debounceTime(5000)
    ).subscribe(() => this._warning_message = '');

    //Danger
    this._danger.subscribe(message => this._danger_message = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this._danger_message = '');
  }

  public set_info(_message) {
    this._info.next(_message);
  }

  public set_success(_message) {
    this._success.next(_message);
  }

  public set_warning(_message) {
    this._warning.next(_message);
  }

  public set_danger(_message) {
    this._danger.next(_message);
  }

  public get_info() {
    return this._info_message;
  }

  public get_success() {
    return this._success_message;
  }

  public get_warning() {
    return this._warning_message;
  }

  public get_danger() {
    return this._danger_message;
  }
}